<template>
  <img alt="Vue logo" src="./assets/logo.svg" width="200" height="80">
  <h1>Пожалуйста, авторизуйтесь с помощью мобильного приложения HID Approve</h1>
  <p>
    Если у вас нет мобильного приложения, обратитесь в техподдержку
  </p>
  <LoginForm/>
</template>

<script>
import LoginForm from './components/LoginForm.vue'

export default {
  name: 'App',
  components: {
    LoginForm: LoginForm
  },
  created() {
    document.title = "HID Approve";
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

</style>
